import {Pipe, PipeTransform} from '@angular/core';
import {TransactionTypeEnum} from '@shared/enums/transaction-type.enum';

@Pipe({
  name: 'findTransactionType'
})
export class FindTransactionTypePipe implements PipeTransform {

  transform(value: keyof typeof TransactionTypeEnum): string {
    for (const i in TransactionTypeEnum) {
      if (i === value) return TransactionTypeEnum[value];
    }

    return '';
  }

}
